<template>
  <div class="sub-main-wrap">
    <div class="gov-bg">
      <div class="text-wrap">
        <div class="gov-title">22대 국회 현황판</div>
        <span class="white-dot"></span>
        <div class="gov-sub">22대 국회의원 법안 발의 및 처리현황</div>
      </div>
    </div>
    <div class="color-bg">
      <div class="green">
        <div class="text-wrap-content">
          <div class="description">법안 처리율 | 법안처리 유형</div>
          <div class="title">
            22대 국회<br />
            법안처리 현황판
          </div>
          <RouterLink class="show-detail" to="/nth-national-assembly"
            >자세히 보기
            <img
              class="arrow-right"
              :src="require('../../assets/img/show-detail-icon.png')"
              alt="자세히보기 아이콘"
          /></RouterLink>
        </div>
      </div>
      <div class="blue">
        <div class="text-wrap-content">
          <div class="description">발의법안 | 처리법안 | 미처리법안</div>
          <div class="title">
            22대 국회의원<br />
            입법 현황판
          </div>
          <RouterLink
            class="show-detail"
            to="/nth-national-assembly?type=congressman"
            >자세히 보기
            <img
              class="arrow-right"
              :src="require('../../assets/img/show-detail-icon.png')"
              alt="자세히보기 아이콘"
          /></RouterLink>
        </div>
      </div>
      <!-- <img
        class="gov-icon"
        :src="require('../../assets/img/22_gov_icon.png')"
        alt="아이콘"
      /> -->
    </div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "SubMainMenu",

  components: { RouterLink },
};
</script>

<style scoped>
.sub-main-wrap {
  position: relative;
  margin-top: 554px;
  height: 692px;

  @media only screen and (max-width: 1040px) {
    margin-top: 1082px;
    height: auto;
  }
}

.gov-bg {
  height: 500px;
  max-width: 1600px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("../../assets/img/22_gov.jpg");
  background-size: cover;
  background-position: center bottom;
  transform: scaleX(-1);
  position: absolute;
  min-width: 1300px;
  z-index: 2;
  border-radius: 20px 0 0 0;

  @media only screen and (max-width: 1040px) {
    width: 100%;
    position: relative;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: none;
    min-width: inherit;
    border-radius: 0;
  }
}

.color-bg {
  position: absolute;
  left: 300px;
  min-width: calc(100% - 300px);
  right: 0;
  height: 400px;
  top: 220px;
  z-index: 2;
  border-radius: 20px 0 0 20px;
  display: flex;

  @media only screen and (max-width: 1040px) {
    position: relative;
    min-width: inherit;
    top: auto;
    left: 0;
    display: flex;
    height: auto;
    flex-direction: column;
  }
}

.green {
  flex-basis: 50%;
  border-radius: 20px 0 0 20px;
  background-color: #0db2ab;
  display: flex;
  word-break: keep-all;
  @media only screen and (max-width: 1040px) {
    border-radius: 0;
  }
}

.blue {
  flex-basis: 50%;
  background-color: #005aab;
  display: flex;
  word-break: keep-all;
}

.gov-icon {
  width: 355px;
  flex: 355px;
  left: calc(100% - 330px);
  position: absolute;
  top: 115px;

  @media only screen and (max-width: 1515px) {
    width: 200px;
    right: 0;
    left: auto;
    bottom: 0;
    top: auto;
  }

  @media only screen and (max-width: 1300px) {
    display: none;
  }
}

.text-wrap-content {
  margin-top: 59px;
  margin-left: 61px;
  font-family: GmarketSansMedium;

  @media only screen and (max-width: 1040px) {
    margin: 59px 0;
    width: 100%;
    text-align: center;
  }
}

.description {
  font-size: 20px;
  font-weight: 300;
  letter-spacing: -0.5px;
  color: #fff;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;

  @media only screen and (max-width: 1040px) {
    font-size: 4vw;
  }
}

.title {
  font-family: GmarketSansMedium;
  font-size: 50px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.25px;
  color: #fff;
  margin-top: 30px;

  @media only screen and (max-width: 1040px) {
    margin-top: 5.9vw;
    font-size: 8vw;
  }
}

.arrow-right {
  vertical-align: middle;
  margin-left: 18px;
}

.show-detail {
  font-family: GmarketSansMedium;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  display: inline-block;
  line-height: normal;
  letter-spacing: -0.5px;
  text-align: left;
  color: #fff;
  position: absolute;
  bottom: 60px;

  @media only screen and (max-width: 1040px) {
    font-size: 4vw;
    margin-top: 5vw;
    position: initial;
    bottom: auto;
  }
}

.text-wrap {
  transform: scaleX(-1);
  display: flex;
  margin-right: 300px;
  gap: 60px;
  margin-top: 99px;
  position: relative;
  color: #fff;
  align-items: baseline;

  @media only screen and (max-width: 1200px) {
    margin-right: 210px;
  }

  @media only screen and (max-width: 1040px) {
    margin: 0;
    display: inline-block;
  }
}

.gov-title {
  font-family: GmarketSansMedium;
  font-size: 50px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.25px;
  color: #fff;

  @media only screen and (max-width: 1040px) {
    font-size: 8vw;
    text-align: center;
  }
}

.white-dot {
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
  left: 367px;

  top: -8px;

  @media only screen and (max-width: 1200px) {
  }

  @media only screen and (max-width: 1040px) {
    right: -9px;
    left: auto;
  }
}

.gov-sub {
  font-family: GmarketSansMedium;
  font-size: 20px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.5px;
  color: #fff;
  @media only screen and (max-width: 1040px) {
    text-align: center;
    margin-top: 24px;
    font-size: 4vw;
  }
}
</style>
